import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { renderChildren } from '../../BlockRenderer/renderChildren.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { getBorderStyle } from '../../utils/getBorderStyle.js';
import { getInnerPadding } from '../../utils/getInnerPadding.js';
import { style } from '../../utils/style.js';
import { gapStyles } from './gapStyles.js';
export const HorizontalLayout = UniBlock(({ className = '', padding = 'p-0', gap = 'XS', isInnerPadding = true, version = 'transparent', isTheme = false, isCardBorder, ...rest }) => (_jsx(BlockWrapper, { className: style('relative', 'grid grid-cols-12', gapStyles[gap], className), padding: padding, version: version, isTheme: isTheme, ...rest, children: renderChildren({
        ...rest,
        extraProps: {
            ...getInnerPadding(isInnerPadding),
            className: getBorderStyle(isCardBorder),
        },
    }) })), {
    childrenTypes: { exclude: ['HorizontalLayout'] },
});
//# sourceMappingURL=HorizontalLayout.js.map